import { render, staticRenderFns } from "./BillsCreate.vue?vue&type=template&id=2eca8f07"
import script from "./BillsCreate.vue?vue&type=script&lang=js"
export * from "./BillsCreate.vue?vue&type=script&lang=js"
import style0 from "./BillsCreate.vue?vue&type=style&index=0&id=2eca8f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports